// 日本語を文節で折り返す。word-break: auto-phrase が使えるブラウザ（Chrome・Edge）では何もしない。
// Safari などでは BudouX で文節の区切りに <wbr> を入れる（文字は変えないので、文面を読む処理には影響しない）。
(() => {
  if (window.CSS && CSS.supports && CSS.supports('word-break', 'auto-phrase')) return;
  const lib = window.JpEcolBudoux;
  if (!lib) return;
  const parser = new lib.Parser(lib.jaModel);
  const processor = new lib.HTMLProcessor(parser, { className: 'jd-phrase', separator: document.createElement('wbr') });
  const TARGET = [
    'main h1', 'main h2', 'main h3', 'main p', 'main li', 'main dt', 'main dd', 'main th', 'main td', 'main figcaption',
    '.jd-footer p', '.jp-ecol-footer p',
  ].join(',');
  // 入力欄・フォーム・カートの明細は触らない（入力中の内容や数量の更新を壊さないため）
  const SKIP = 'form, input, textarea, select, button, script, style, [contenteditable], cart-items, .cart-item, [data-jp-ecol-no-phrase]';
  const apply = (root) => {
    root.querySelectorAll(TARGET).forEach((el) => {
      if (el.closest(SKIP) || el.dataset.jdPhrase) return;
      if (!/[぀-ヿ㐀-鿿]/.test(el.textContent)) return;
      el.dataset.jdPhrase = '1';
      try { processor.applyToElement(el); } catch (e) { /* 区切りを入れられない要素はそのまま表示する */ }
    });
  };
  const run = () => apply(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
